
import { useEffect, useRef, useState } from 'react';

import useAutoBlockedModalStore from '../store/useAutoBlockedModal.store';

interface Props {
  visible?: boolean;
}

const useAutoBlockedModal = ({ visible }: Props) => {
  const { pushModalLayer, popModalLayer, isTopModal, modalLayers } = useAutoBlockedModalStore();
  const [modalLayer, setModalLayer] = useState<number | null>(null);
  const wasVisible = useRef<boolean>(false);
  const scrollPosition = useRef<number>(0);

  useEffect(() => {
    if (visible) {
      const currentModalLayer = pushModalLayer();
      setModalLayer(currentModalLayer);
      wasVisible.current = true;
    }
  }, [visible, pushModalLayer]);

  useEffect(() => {
    if (wasVisible.current && !visible) {
      popModalLayer();
    }
  }, [visible, popModalLayer]);

  useEffect(() => {
    return () => {
      popModalLayer();
    };
  }, [popModalLayer]);

  useEffect(() => {
    const hasOpenModals = modalLayers.length > 0;

    if (hasOpenModals) {
      if (modalLayers.length === 1) {
        scrollPosition.current = window.scrollY;
      }
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition.current}px`;
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition.current);
    }
  }, [modalLayers.length]);

  return {
    isClosingByClickOutsideBlocked: Boolean(modalLayer && !isTopModal(modalLayer)),
  };
};

export default useAutoBlockedModal;